export const RIDER_REGISTRATION_REASON_CODES = ['rider_asked_by_phone', 'rider_asked_in_person', 'partner_onboarding', 'data_correction', 'other'];
export const PHONE_CHANGE_REASON_CODES = ['phone_lost', 'phone_new_number', 'phone_typo_correction', 'other'];
const enc = encodeURIComponent;
export class AccountRegistryApi {
    client;
    constructor(client) {
        this.client = client;
    }
    registerRider(input) {
        return this.client.request({ method: 'POST', path: '/v1/ops/riders', body: input, auth: true });
    }
    registration(userId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${enc(userId)}/registration`, auth: true });
    }
    proposePhoneChange(userId, input) {
        return this.client.request({ method: 'POST', path: `/v1/ops/users/${enc(userId)}/phone-change`, body: input, auth: true });
    }
    phoneChangeQueue(state = 'PENDING') {
        return this.client.request({ method: 'GET', path: `/v1/ops/phone-change-requests?state=${enc(state)}`, auth: true });
    }
    /** D502 (Q-015): the proposer enters the code the person read out from the NEW number (the server counts wrong tries and locks after five). */
    verifyPhoneNumber(requestId, code) {
        return this.client.request({ method: 'POST', path: `/v1/ops/phone-change-requests/${enc(requestId)}/verify-number`, body: { code }, auth: true });
    }
    /** D502 (Q-015): a fresh code to the NEW number (the old one stops working; bounded per account and operator). */
    resendPhoneNumberCode(requestId) {
        return this.client.request({ method: 'POST', path: `/v1/ops/phone-change-requests/${enc(requestId)}/resend-code`, body: {}, auth: true });
    }
    /** approve (a DIFFERENT operator; the phone moves and the sessions end), reject, or withdraw (the proposer). */
    decidePhoneChange(requestId, action, note) {
        const body = note !== undefined && note.trim() !== '' ? { note: note.trim() } : {};
        return this.client.request({ method: 'POST', path: `/v1/ops/phone-change-requests/${enc(requestId)}/${action}`, body, auth: true });
    }
}
//# sourceMappingURL=account-registry.js.map